import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IInsuranceContractsState, IList, TError } from './types/InsuranseContracts-interface'

const ContractsListState = (state: RootState): IInsuranceContractsState => state.insuranceContractsList

export const ContractsList = createSelector(
    [ContractsListState],
    (state): IList[] => state.list,
)
export const CountContractsList = createSelector(
    [ContractsListState],
    (state): number => state.ContractCount,
)
export const LoadingContractsList = createSelector(
    [ContractsListState],
    (state): boolean => state.isLoadingList,
)
export const ErrorContractsList = createSelector(
    [ContractsListState],
    (state): TError => state.errorList,
)

export const LastFetchContractsList = createSelector(
    [ContractsListState],
    (state): null | number => state.lastFetchTime,
)
export const CurrentPageContractsList = createSelector(
    [ContractsListState],
    (state): number => state.currentPage,
)

export const Download = createSelector(
    [ContractsListState],
    (state): boolean => state.isDownload,
)
export const ErrorDownload = createSelector(
    [ContractsListState],
    (state): TError => state.errorDownload,
)
export const FileData = createSelector(
    [ContractsListState],
    (state): string => state.FileData,
)
export const FileName = createSelector(
    [ContractsListState],
    (state): string => state.FileName,
)